import React, { CSSProperties } from "react";
import { useRouter } from "next/router";
import { Sidebar, WithSidebarContainer } from "modules/layout";
import pages from "pages/_router";
import { CompanyLayout } from "../_layout";

export interface ICompanySettingsLayout {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CompanySettingsLayout = (props: ICompanySettingsLayout) => {
  const router = useRouter();
  const slug = router.query.company as string;

  return (
    <CompanyLayout title="Настройки" className={props.className} style={props.style} htmlId={props.htmlId}>
      <WithSidebarContainer
        mainHref={pages.company(slug).settings.href}
        sidebar={
          <Sidebar
            mainHref={pages.company(slug).settings.href}
            menu={[
              {
                label: "Общие",
                href: pages.company(slug).settings.href,
                exact: true,
                additionalHref: pages.company(slug).settings.general.href,
              },
              { label: "Сотрудники", href: pages.company(slug).settings.users.href },
              { label: "Роли", href: pages.company(slug).settings.roles.href },
            ]}
          />
        }
      >
        {props.children}
      </WithSidebarContainer>
    </CompanyLayout>
  );
};
